import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";

import { DeleteButton, PlusButton } from "components/atoms/Buttons";
import { TASKS_OPTIONS, TASKS_STATUSES } from "consts/tasks";
import { IssueApi } from "api/issuesApi";
import {
  PaziaButton,
  PaziaInput,
  PaziaSelect,
  PaziaMultiSelect,
  PaziaTextarea,
  PaziaDateSelect,
} from "components/atoms";
import { useAdminUsersOptions } from "api/admin-users/useAdminUsers";

export type TaskResourceType =
  | "course"
  | "trainer"
  | "student"
  | "topic"
  | "topicGroup"
  | "place"
  | "payment-discount"
  | "dictionary"
  | "document-type"
  | "email-template"
  | "survey"
  | "exam"
  | "general";
export interface TaskResource {
  type: TaskResourceType;
  link?: string;
  id?: number;
}

interface TaskFormProps {
  resource?: TaskResource;
  issue?: IssueApi;
  onSuccessSubmit: (data: TaskFormValues) => Promise<void>;
}
// TODO na mobilce wyglada lipnie
export const TaskForm = ({ issue, resource, onSuccessSubmit }: TaskFormProps) => {
  const { loading: loadingAdmins, options: adminOptions } = useAdminUsersOptions();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      link: resource?.link ?? issue?.link,
      title: issue?.title,
      description: issue?.description,
      dueDate: issue?.dueDate,
      status: issue?.status ?? TASKS_STATUSES.TODO,
      assignees: issue?.assignees?.map((assignee) => assignee.id),
      items: issue?.issueItems?.map((item) => ({ name: item.name })),
    },
  });
  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    keyName: "key",
    name: FORM_NAMES.ITEMS,
  });
  const { handleSubmit, setValue } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSuccessSubmit)} className="flex h-full flex-col gap-4">
        <PaziaInput name={FORM_NAMES.TITLE} label="Tytuł" required />
        <PaziaTextarea name={FORM_NAMES.DESCRIPTION} label="Opis" rows={6} />
        <PaziaDateSelect name={FORM_NAMES.DUEDATE} label="Termin" />
        <div className="gap-2 md:flex">
          <PaziaSelect name={FORM_NAMES.STATUS} label="Status" options={TASKS_OPTIONS} required className="md:w-1/2" />

          <PaziaMultiSelect
            name={FORM_NAMES.ASSINGEES}
            label="Przypisz do"
            options={adminOptions}
            className="md:w-1/2"
            disabled={loadingAdmins}
          />
        </div>
        {fields.length < 1 ? (
          <></>
        ) : (
          // <div
          //   className="text-sm cursor-pointer hover:text-primary-700"
          //   // TODO TO NIE dziala onClick={() => append({ name: "" })}
          // >
          //   + Dodaj liste zadań
          // </div>
          <>
            <div>Lista zadań</div>
            {fields.map((field, index) => (
              <div className="flex items-center gap-2">
                <div>{index + 1}</div>
                <PaziaInput name={`${FORM_NAMES.ITEMS}[${index}].name`} className="w-full" />
                <DeleteButton onClick={() => remove(index)} className="h-9 w-9" />
              </div>
            ))}
            <div className="flex justify-end">
              <PlusButton onClick={() => append({ name: "" })} />
            </div>
          </>
        )}
        <div className="flex items-end gap-2">
          <PaziaInput name={FORM_NAMES.LINK} label="Link" disabled className="w-full" />
          <DeleteButton onClick={() => setValue(FORM_NAMES.LINK, "")} className="h-9 w-9" />
          {/* TODO Revert */}
        </div>
        <div className="flex h-full items-end justify-end">
          <PaziaButton type="success" title={issue ? "Zapisz" : "Dodaj"} onClick={() => {}} className="self-end" />
        </div>
      </form>
    </FormProvider>
  );
};
const FORM_NAMES = {
  LINK: "link",
  TITLE: "title",
  DESCRIPTION: "description",
  ASSINGEES: "assignees",
  ITEMS: "items",
  STATUS: "status",
  DUEDATE: "dueDate",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.TITLE]: yup.string().required(),
    [FORM_NAMES.LINK]: yup.string().nullable(),
    [FORM_NAMES.DESCRIPTION]: yup.string(),
    [FORM_NAMES.DUEDATE]: yup.date().nullable(),
    [FORM_NAMES.STATUS]: yup.number().required(),
    [FORM_NAMES.ASSINGEES]: yup.array(yup.number()),
    [FORM_NAMES.ITEMS]: yup.array(
      yup.object({
        name: yup.string().required(),
      }),
    ),
  })
  .required();
export type TaskFormValues = yup.InferType<typeof schema>;
